import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { SummaryTitle } from '../../summary/common/summary_title';
import { SummarySubTitle } from '../../summary/common/summary_sub_title';

const NoQuotesSummary = ({ titleClassName, subTitleClassName, className }) => {
    return (
        <div className={classNames('test-emptyState-summary', className)}>
            <SummaryTitle className={titleClassName} />
            <SummarySubTitle className={subTitleClassName} />
        </div>
    );
};

NoQuotesSummary.propTypes = {
    className: PropTypes.string,
    titleClassName: PropTypes.string,
    subTitleClassName: PropTypes.string
};

export { NoQuotesSummary };
